'use strict';

var _ = require('underscore');

module.exports = function(value) {
	return _(value).isObject() && !_(value).isArray() &&
		!_(value).isRegExp() && !_(value).isDate();
};
